<template>
  <div class="flex-container">
    <div class="label" v-if="check">
      <p>{{ label }}</p>
      <br v-if="brCheck && !isCheckSizeSmall" />
    </div>
    <div class="border-left"></div>
    <div class="content" v-if="check">
      <span class="device-info">{{ value }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: null,
      required: true,
    },
    check: {
      type: null,
      required: true,
    },
    brCheck: {
      type: Boolean,
      default: false,
    },
    isCheckSizeSmall: {
      type: Boolean,
    },
  },
};
</script>

<style scoped>
.flex-container {
  display: flex;
}

.label {
  flex: 0 0 37%;
}

.border-left {
  border-left: 1px solid #707079;
}

.content {
  padding-left: 5px;
  display: block;
  word-wrap: break-word;
}

.device-info {
  font-weight: 400 !important;
  padding-left: 5px;
  font-size: 15px;
  word-wrap: break-word;
  font-family: 'Montserrat', sans-serif;
}
.v-application p {
  font-weight: 600;
  margin-bottom: 8px;
  font-size: 15px;
  font-family: 'Montserrat', sans-serif;
}
@media screen and (max-width: 800px) {
  .label {
    flex: 0 0 50%;
  }
  .device-info {
    font-size: 14px;
  }
  .content {
    padding-top: 5px;
  }
  .v-application p {
    font-size: 15px;
    padding-top: 5px;
  }
}
</style>
